// @flow
/* globals document, window */
import React, { Fragment } from "react";
import GlobalAlert from "../common/GlobalAlert";
import BlogPost from "./BlogPost";
import { GlobalProvider } from "../common/GlobalContext";

import type {
  $TransformedBlogPost,
  $Site,
  $SiteUser,
  ComplianceItems,
  $Alerts,
} from "flow/types";
type $Props = {
  alerts: Array<$Alerts>,
  CDN_IMAGE_SERVER_URL: string,
  compliance: ComplianceItems,
  favorites: Array<number>,
  RECAPTCHA_CLIENT: string,
  RECAPTCHA_CLIENT_V2: String,
  post: $TransformedBlogPost,
  image: string,
  site: $Site,
  siteUser: $SiteUser,
  theme: Object, // theme from the API/site settings, not the react-jss theme
  title: string,
};

const BlogDetail = (props: $Props) => {
  const {
    alerts,
    CDN_IMAGE_SERVER_URL,
    compliance,
    favorites,
    post,
    RECAPTCHA_CLIENT,
    RECAPTCHA_CLIENT_V2,
    site,
    siteUser,
    theme,
    image,
  } = props;

  return (
    <GlobalProvider
      compliance={compliance}
      favorites={favorites}
      siteUser={siteUser}
      theme={theme}
      CDN_IMAGE_SERVER_URL={CDN_IMAGE_SERVER_URL}
      RECAPTCHA_CLIENT={RECAPTCHA_CLIENT}
      RECAPTCHA_CLIENT_V2={RECAPTCHA_CLIENT_V2}
    >
      <Fragment>
        <GlobalAlert alerts={alerts} />
        <BlogPost post={post} image={image} site={site} />
      </Fragment>
    </GlobalProvider>
  );
};

export default BlogDetail;
